export default "__VITE_ASSET__DOa9n1dV__"